/**
 * Los rubros que se ofrecen, en un módulo propio.
 *
 * Vive acá y no en la pantalla del alta porque lo usan dos: el alta, que
 * pregunta una vez, y la pantalla de Configuración, que deja corregirlo después.
 * Duplicar la lista es cómo terminan ofreciendo opciones distintas.
 *
 * `real_estate` va aparte: es el único rubro que hoy cambia la aplicación
 * —habilita Propiedades, visitas y los campos de búsqueda— y en el alta se
 * muestra primero y solo, para que no se pierda en una lista de nueve.
 */
export const REAL_ESTATE = { value: "real_estate", label: "Inmobiliaria" } as const;

export const RUBROS: readonly { value: string; label: string; hint?: string }[] = [
  { value: "health", label: "Salud" },
  { value: "education", label: "Educación" },
  { value: "retail", label: "Comercio" },
  { value: "services", label: "Servicios profesionales" },
  { value: "automotive", label: "Automotor" },
  { value: "hospitality", label: "Gastronomía y turismo" },
  { value: "software", label: "Software y tecnología" },
  { value: "other", label: "Otro" },
];

/** Todos, para una pantalla que deja elegir cualquiera. */
export const TODOS_LOS_RUBROS = [REAL_ESTATE, ...RUBROS];
